<template>
  <BreadCrumb PageTitle="Blank Page" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../template-components/Common/BreadCrumb.vue";

export default defineComponent({
  name: "BlankPage",
  components: {
    BreadCrumb,
  },
});
</script>